var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAEIElEQVR4Ae2aMWgUQRSGgyDYWsTOeu8UA5ImNiJaiY0pUlgJsd89NIhaSIJo1ErIpdBCUEhtCkMuEQQtBYtACsGksUlhEXc2gbtobuSb3XdeLuexe7e5JZkdWGZvePO/N/++eTP3ZgYG8pIzkDOQM5AzkDOQM5AFA7NL+jRPFroz1fn6sx4sV6ofZxarmod32jI1qp/Ky5XanAxeatr6aUOmumYqtU0ZeKOu1DYzNaqfymcWq2uNgUfTgLZ+2pCprtmlnVutBNCWqVH9Vl5ero2WK7V58yzXRvut/0D0nb8fDJ4tBZcdTzmTk/pYWkrAAhNsdKSFmxrOGXfrSsFT3xzX1/IUXD8oeP7U8Et9vFtF9AUDLMGlRhc6u8VNtV/R8x85rqpj2IUHgb5Z3tZXH29hZEiGp1bO3dMnkyqlj+OpFXCLJWUwwUZHSIaqozspbqryfAUGP3RH6befarq5rP7Y1deebBljC556k1QxfRgoGGA1F3ShE92ZeoK4fevgxdiNzboevht6QvG2PxKXBGQZPH3BaFfQiQw2xMVNVY5ghAG4ZKfy9F01NLSkJuIaUCipCbDp26nIdMgkMJpo7/pmzncycv7Ljnyp2NNA3J++nQoxAaKwJS65qcmxLKGcgNepvPrQcNXpuMoLnpoGm76dCrqRw5a42KnJsTazPBGhW4OUGL1b1/r6MzEyGIur3PGCMQY2+nxLg9GuoJOVBhvS3HPEtdHIsUZjKJG6NVhh+I0XoYsWS+r7pUl9Ii44svQBG4xWEtD1b4Xxp+Lipi7HRkXWaiI2QYt5i+s2vnzooutJApUJsJ5aN+4deQKYYKNDVhZ097LRSoUQNiwStMRgqc1XjAZS8NRqHBKQQdZgeGpdPEEwpUZnNxusVAbdDoS1m+ULw0wQ84IxXLl5QEKCU1LjjqcWCq7a4OGdtnayYBATwDTYJTWRZE/Rzta+tzUPzGnZ18sXjWqz5xei+m7oQSqEBBn8xYeBfv/1t/6p6ubhnTYhAdmDtCURdpjArM1Faay1bhMXxu1d3wz01/b+hY22BgklNZ7IyEg4SrSsYSs5xlQSrc3ZW8nikMxIaqCZ565vvvz+4YcteILxAk8tJMXHJrFPamxPirNHnpy9gDXXZHH2CMb4YYKd6xuX/x8BTAkIQDYG5B4RbGq2Ud57OnewngAotnoKQID1QXDPROvhx6FdBnsYc6OrFRsha7fCVv8ZOqi/w0MTwSnnMPwd7pQQ+bN7xBMi1qfErE+KWp8WjzY2mR6MjETnhJnlD6w+GmObZ/3hKCRYfTwum308QaZDlNczJzZWXJAQEqgJRmZ1sO2KTDMJcd+P5CWpuIO3/pqc9Rclrb8qa/1l6TDRavF1eQmWnDv0dHAhQHmdM5AzkDOQM5AzkDPQDQN/AV82rQrNFptPAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPub);
export default __webpack_public_path__ + "static/media/pub.82c4de185ea724d9384680364d96ce1f.svg";
export { ForwardRef as ReactComponent };